<template>
  <div class="inline-block">
    <!-- Trigger Button -->
    <div
      class="dropdown-trigger inline-flex items-center px-5 py-2 font-medium text-sm rounded-lg transition-all duration-150 shadow mr-3"
      style="background-color: #fff; color: #575757; cursor: pointer;"
      @click="toggleDropdown"
      @mouseenter="onTriggerHover(true)"
      @mouseleave="onTriggerHover(false)"
      ref="dropdownTrigger"
    >
      <span style="margin-right: 8px;">Descargar</span>
      <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
    </div>

    <vs-prompt
      @accept="keepDownload"
      @close="closePrompt"
      title="Aviso"
      accept-text="Aceptar"
      cancel-text="Cancelar"
      :active.sync="nom151Prompt">
      <div>
        El archivo de Constancia de Conservación se encuentra en formato ASN.1 el cual requiere un visor asociado y se recomienda para usuarios avanzados.
        <br>
        <a href="https://ayuda.verificamex.com" target="_blank">Conoce más acerca del formato ASN.1</a>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
export default {
  name: "DownloadDropDown",
  props: ["document"],
  data() {
    return {
      nom151Prompt: false,
      uuid: null,
      dropdownEl: null,
      isDropdownOpen: false
      // Eliminamos la referencia al overlayEl
    }
  },
  mounted() {
    // Crear elementos DOM directamente
    this.createDropdownElements();

    // Configurar estilo CSS para el botón cuando se cargue
    if (this.$refs.dropdownTrigger) {
      this.$refs.dropdownTrigger.style.transition = 'all 0.2s ease';
    }

    // Agregar event listener para cerrar al hacer clic fuera
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    // Limpiar
    document.removeEventListener('click', this.handleClickOutside);
    this.removeDropdown();
  },
  methods: {
    onTriggerHover(isHovering) {
      if (!this.$refs.dropdownTrigger) return;

      if (isHovering) {
        // Efecto de elevación
        this.$refs.dropdownTrigger.style.transform = 'translateY(-1px)';
        this.$refs.dropdownTrigger.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.1)';
        this.$refs.dropdownTrigger.style.backgroundColor = '#f8f9fa';
      } else {
        // Volver al estado normal
        this.$refs.dropdownTrigger.style.transform = 'translateY(0)';
        this.$refs.dropdownTrigger.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.05)';
        this.$refs.dropdownTrigger.style.backgroundColor = '#fff';
      }
    },
    createDropdownElements() {
      // Eliminar referencia al overlay ya que no lo usaremos

      // Crear el dropdown
      this.dropdownEl = document.createElement('div');
      this.dropdownEl.className = 'dropdown-menu-container';
      this.dropdownEl.style.cssText = 'z-index: 9999; display: none; position: fixed; background-color: white; border-radius: 8px; box-shadow: 0 4px 12px -2px rgba(0,0,0,0.15); border: 1px solid rgba(0,0,0,0.1); width: 224px; overflow: hidden; opacity: 0; transform: scale(0.95); transition: opacity 0.15s ease-out, transform 0.15s ease-out;';
      document.body.appendChild(this.dropdownEl);

      // Crear los items del dropdown
      this.updateDropdownItems();
    },
    updateDropdownItems() {
      // Limpiar contenido anterior
      if (this.dropdownEl) {
        this.dropdownEl.innerHTML = '';

        // Constancia de conservación
        if (this.document['sign_status'] === 3) {
          this.createMenuItem('Constancia de conservación', () => this.downloadNom151(this.document['uuid']));
        }

        // XML
        if (this.document['sign_status'] === 3) {
          this.createMenuItem('XML', () => this.downloadXml(this.document['uuid']));
        }

        // PDF Firmado
        if (this.document['sign_status'] === 3) {
          this.createMenuItem('PDF Firmado', () => this.downloadPdf(this.document['uuid']));
        }

        // PDF Original
        this.createMenuItem('PDF Original', () => this.downloadPdfOriginal(this.document['uuid']));

        // Expediente en ZIP
        if (this.document['sign_status'] === 3) {
          this.createMenuItem('Expediente en ZIP', () => this.downloadAll(this.document['uuid']));
        }

        // Divider
        if (this.document['sign_status'] === 3) {
          this.createDivider();

          // Validar documento
          const validateLink = document.createElement('a');
          validateLink.className = 'dropdown-menu-item';
          validateLink.textContent = 'Validar documento';
          validateLink.href = `/signature/verify/${this.document['uuid']}`;
          validateLink.style.cssText = 'display: block; padding: 10px 16px; color: #374151; text-decoration: none; transition: all 0.2s ease;';
          validateLink.onmouseenter = (e) => {
            e.target.style.backgroundColor = '#f3f4f6';
            e.target.style.color = '#111827';
            e.target.style.transform = 'translateX(4px)';
          };
          validateLink.onmouseleave = (e) => {
            e.target.style.backgroundColor = 'transparent';
            e.target.style.color = '#374151';
            e.target.style.transform = 'translateX(0)';
          };
          this.dropdownEl.appendChild(validateLink);
        }
      }
    },
    createMenuItem(text, onclick) {
      const menuItem = document.createElement('div');
      menuItem.className = 'dropdown-menu-item';
      menuItem.textContent = text;
      menuItem.style.cssText = 'display: block; padding: 10px 16px; color: #374151; cursor: pointer; transition: all 0.2s ease;';
      menuItem.onclick = (e) => {
        e.stopPropagation();
        onclick();
        this.closeDropdown();
      };
      menuItem.onmouseenter = (e) => {
        e.target.style.backgroundColor = '#f3f4f6';
        e.target.style.color = '#111827';
        e.target.style.transform = 'translateX(4px)';
      };
      menuItem.onmouseleave = (e) => {
        e.target.style.backgroundColor = 'transparent';
        e.target.style.color = '#374151';
        e.target.style.transform = 'translateX(0)';
      };
      this.dropdownEl.appendChild(menuItem);
    },
    createDivider() {
      const divider = document.createElement('div');
      divider.className = 'dropdown-menu-divider';
      divider.style.cssText = 'border-top: 1px solid #e5e7eb; margin: 4px 0;';
      this.dropdownEl.appendChild(divider);
    },
    toggleDropdown() {
      if (this.isDropdownOpen) {
        this.closeDropdown();
      } else {
        this.openDropdown();
      }
    },
    openDropdown() {
      if (!this.dropdownEl || !this.$refs.dropdownTrigger) return;

      // Actualizar elementos del dropdown basados en el estado actual
      this.updateDropdownItems();

      // Posicionar el dropdown
      const triggerRect = this.$refs.dropdownTrigger.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const viewportWidth = window.innerWidth;

      // Mostrar para calcular altura
      this.dropdownEl.style.display = 'block';
      this.dropdownEl.style.visibility = 'hidden';
      this.dropdownEl.style.opacity = '0';
      this.dropdownEl.style.transform = 'scale(0.95)';

      const dropdownHeight = this.dropdownEl.offsetHeight;

      // Calcular posición
      const spaceBelow = viewportHeight - triggerRect.bottom;
      const spaceAbove = triggerRect.top;

      if (spaceBelow < dropdownHeight && spaceAbove > dropdownHeight) {
        // Mostrar arriba
        this.dropdownEl.style.top = 'auto';
        this.dropdownEl.style.bottom = (viewportHeight - triggerRect.top + 5) + 'px';
      } else {
        // Mostrar abajo
        this.dropdownEl.style.top = (triggerRect.bottom + 5) + 'px';
        this.dropdownEl.style.bottom = 'auto';
      }

      // Posición horizontal
      if (triggerRect.left + 224 > viewportWidth) {
        this.dropdownEl.style.right = '10px';
        this.dropdownEl.style.left = 'auto';
      } else {
        this.dropdownEl.style.left = triggerRect.left + 'px';
        this.dropdownEl.style.right = 'auto';
      }

      // Mostrar dropdown con animación
      this.dropdownEl.style.visibility = 'visible';

      // Trigger reflow para asegurar que la animación funcione
      void this.dropdownEl.offsetWidth;

      this.dropdownEl.style.opacity = '1';
      this.dropdownEl.style.transform = 'scale(1)';
      this.isDropdownOpen = true;
    },
    closeDropdown() {
      if (this.dropdownEl) {
        // Animación de cierre
        this.dropdownEl.style.opacity = '0';
        this.dropdownEl.style.transform = 'scale(0.95)';

        // Ocultar después de que termine la animación
        setTimeout(() => {
          this.dropdownEl.style.display = 'none';
          this.isDropdownOpen = false;
        }, 150); // Tiempo de transición
      }
    },
    removeDropdown() {
      if (this.dropdownEl && this.dropdownEl.parentNode) {
        this.dropdownEl.parentNode.removeChild(this.dropdownEl);
      }
      // Eliminamos la referencia al overlay ya que no lo usamos
    },
    handleClickOutside(event) {
      if (this.isDropdownOpen) {
        const isClickInsideTrigger = this.$refs.dropdownTrigger && this.$refs.dropdownTrigger.contains(event.target);
        const isClickInsideDropdown = this.dropdownEl && this.dropdownEl.contains(event.target);

        if (!isClickInsideTrigger && !isClickInsideDropdown) {
          this.closeDropdown();
        }
      }
    },
    // Métodos originales para descargas
    downloadXml(uuid) {
      this.$store.dispatch("document/downloadXml", {uuid: uuid})
    },
    downloadPdfOriginal(uuid) {
      this.$store.dispatch("document/downloadPdfOriginal", {uuid: uuid})
    },
    downloadPdf(uuid) {
      this.$store.dispatch("document/downloadPdf", {uuid: uuid})
    },
    keepDownload() {
      this.$store.dispatch("document/downloadNom151", {uuid: this.uuid})
    },
    downloadNom151(uuid) {
      this.uuid = uuid;
      this.nom151Prompt = true;
    },
    downloadAll(uuid) {
      this.$store.dispatch("document/downloadAll", {uuid: uuid});
    },
    closePrompt() {
      this.nom151Prompt = false;
    }
  }
}
</script>
